export const colors = [
  '#FF1744',
  '#FF5722',
  '#FFC107',
  '#EEFF41',
  '#76FF03',
  '#00E676',
  '#1DE9B6',
  '#00E5FF',
  '#2979FF',
  '#651FFF',
  '#D500F9',
  '#F50057',
  '#FF4081',
  '#FF80AB',
  '#FFEA00',
  '#C6FF00',
  '#B2FF59',
  '#69F0AE',
  '#64FFDA',
  '#18FFFF',
  '#82B1FF',
  '#7C4DFF',
  '#B388FF',
  '#E040FB',
  '#EA80FC',
  '#FF5252',
  '#FF8A65',
  '#FFD180',
  '#FFFF8D',
  '#CCFF90',
  '#A7FFEB',
  '#80D8FF',
];

export function colorFromUserId(userId: string) {
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = (hash << 5) - hash + userId.charCodeAt(i);
    hash |= 0;
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
}
